module.exports = __webpack_public_path__ + "static/media/Emmanuel-Afolabi-Film-Production.ec3ff439.jpg";